import { Action, createReducer, on } from '@ngrx/store';
import * as userActions from './actions';
import { UserState } from './state';

export const initialUserState: Partial<UserState> = {};

export const userReducer = createReducer(
  initialUserState,
  on(userActions.SetUser, (_, { user }) => user)
)

export function reducers(state: UserState | undefined, action: Action): Partial<UserState> {
  return userReducer(state, action)
}
